import { Text } from '@kanda-libs/ks-design-library';
import useCalculateMonthlyPaymentsButton from './useCalculateMonthlyPaymentsButton';

const CalculateMonthlyPaymentsButton: React.FunctionComponent = function () {
  const { onClick, className, isLoading } = useCalculateMonthlyPaymentsButton();
  return (
    <button
      type="button"
      onClick={onClick}
      className={className}
      disabled={isLoading}
      aria-label="calculate-monthly-payments"
    >
      <Text
        text="How much will I pay monthly?"
        className="text-inherit"
        isLoading={isLoading}
      />
    </button>
  );
};

export default CalculateMonthlyPaymentsButton;
